import React from 'react';
import { Certification } from '../../../../../types/resume';
import { Award, Building2, Calendar, Link2, Trash2 } from 'lucide-react';
import Input from '../../../../ui/Input';

interface Props {
  certification: Certification;
  index: number;
  onUpdate: (id: string, updates: Partial<Certification>) => void;
  onRemove: (id: string) => void;
}

export default function CertificationItem({ certification, index, onUpdate, onRemove }: Props) {
  return (
    <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
      <div className="flex justify-between items-center mb-6">
        <h3 className="text-lg font-semibold">Certification {index + 1}</h3>
        <button
          onClick={() => onRemove(certification.id)}
          className="text-red-500 hover:text-red-600"
        >
          <Trash2 className="h-5 w-5" />
        </button>
      </div>

      <div className="space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="relative">
            <Award className="absolute left-3 top-9 h-5 w-5 text-gray-400" />
            <Input
              label="Certification Name"
              value={certification.name}
              onChange={(e) => onUpdate(certification.id, { name: e.target.value })}
              placeholder="e.g. AWS Certified Solutions Architect"
              className="pl-10"
              required
            />
          </div>
          <div className="relative">
            <Building2 className="absolute left-3 top-9 h-5 w-5 text-gray-400" />
            <Input
              label="Issuing Organization"
              value={certification.issuer}
              onChange={(e) => onUpdate(certification.id, { issuer: e.target.value })}
              placeholder="e.g. Amazon Web Services"
              className="pl-10"
              required
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="relative">
            <Calendar className="absolute left-3 top-9 h-5 w-5 text-gray-400" />
            <Input
              type="month"
              label="Issue Date"
              value={certification.issueDate}
              onChange={(e) => onUpdate(certification.id, { issueDate: e.target.value })}
              className="pl-10"
              required
            />
          </div>
          <div className="relative">
            <Calendar className="absolute left-3 top-9 h-5 w-5 text-gray-400" />
            <Input
              type="month"
              label="Expiry Date (Optional)"
              value={certification.expiryDate}
              onChange={(e) => onUpdate(certification.id, { expiryDate: e.target.value })}
              className="pl-10"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="relative">
            <Award className="absolute left-3 top-9 h-5 w-5 text-gray-400" />
            <Input
              label="Credential ID"
              value={certification.credentialId}
              onChange={(e) => onUpdate(certification.id, { credentialId: e.target.value })}
              placeholder="e.g. ABC123XYZ"
              className="pl-10"
            />
          </div>
          <div className="relative">
            <Link2 className="absolute left-3 top-9 h-5 w-5 text-gray-400" />
            <Input
              label="Credential URL"
              type="url"
              value={certification.url}
              onChange={(e) => onUpdate(certification.id, { url: e.target.value })}
              placeholder="https://..."
              className="pl-10"
            />
          </div>
        </div>
      </div>
    </div>
  );
}